import React from "react";
import { Link } from "react-router-dom";
import { Gonjong } from "@/components/Gonjong";

const NotFound = () => (
  <main data-testid="not-found-page" className="bg-rice">
    <section className="relative bg-ink text-rice">
      <div className="mx-auto flex max-w-6xl flex-col items-center px-4 pb-24 pt-20 text-center sm:px-6">
        <p className="font-display text-7xl font-black text-kunyit sm:text-8xl">404</p>
        <h1
          data-testid="not-found-h1"
          className="mt-4 font-display text-3xl font-black sm:text-4xl"
        >
          Halaman ini tidak ditemukan
        </h1>
        <p className="mt-4 max-w-md text-base leading-relaxed text-rice/80">
          Sepertinya hidangan yang Anda cari tidak ada di meja kami. Mari
          kembali ke beranda atau lihat menu kami.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="rounded-full bg-lado px-7 py-3.5 text-base font-bold text-rice transition-transform hover:-translate-y-0.5"
          >
            Kembali ke Beranda
          </Link>
          <Link
            to="/menu/"
            data-testid="not-found-menu-link"
            className="rounded-full border-2 border-rice/70 px-7 py-3.5 text-base font-bold text-rice transition-colors hover:border-kunyit hover:text-kunyit"
          >
            Lihat Menu
          </Link>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 text-rice">
        <Gonjong />
      </div>
    </section>
  </main>
);

export default NotFound;
